<div class="header">
    <div class="header-logo">
        <div class="side-logo">
            <img src="../../../assets/website-assets/images/baba_balak_nath_logo.png" alt="BBN Temple Logo">
        </div>
        <div class="main-logo">
            <img src="../../../assets/images/full-logo1.png" alt="BBN Temple Logo">
        </div>
    </div>
    <div class="text-center">
        <h3>ONLINE SERVICES</h3>
    </div>
</div>

